import {apiSlice} from '../apiSlice';

const VEHICLE_URL = '/vehicles';

export const vehicleApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getVehicle: builder.query({
            query: (data) => ({
                url: `${VEHICLE_URL}`,
                method: 'GET',
                headers: {
                    "x-access-token": data
                }
            })
        }),
        getVehicleById: builder.query({
            query: ({token, id}) => ({
                url: `${VEHICLE_URL}/${id}`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            }),
            invalidatesTags: [{type: 'Vehicle', id: 'LIST'}]
        }),
        deleteVehicleById: builder.mutation({
            query: ({token, id}) => ({
                url: `${VEHICLE_URL}/delete/${id}`,
                method: 'DELETE',
                headers: {
                    "x-access-token": token
                }
            })
        }),
        updateVehicleById: builder.mutation({
            query: ({token, data, id}) => ({
                url : `${VEHICLE_URL}/update/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    "x-access-token" : token
                }
            })
        }),
        newVehicle: builder.mutation({
            query: ({token, data}) => ({
                url: `${VEHICLE_URL}/new`,
                method: 'POST',
                body: data,
                headers: {
                    "x-access-token": token
                }
            }),
            invalidatesTags: [{type: 'Vehicle', id: 'LIST'}]
        }),
    }),
});

export const {
    useGetVehicleQuery,
    useDeleteVehicleByIdMutation,
    useUpdateVehicleByIdMutation,
    useGetVehicleByIdQuery,
    useNewVehicleMutation
} = vehicleApiSlice;
